import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { io } from "socket.io-client";

import { useEffect, useState } from "react";
import Header from "./components/header";
import LandingPage from "./pages/Landing";
// import PaymentPage from "./pages/Payment";
import CreateAccountPage from "./pages/CreateAccount";
import "./styles/App.css";
import "./styles/CreateAccount.css";
import "./styles/Dashboard.css";
import "./styles/Laptimes.css";
import "./styles/Coach.css";
import "./styles/Settings.css";
import "./styles/ChangePassword.css";
import "./styles/EmailConfirm.css";
import PaymentPage from "./pages/Payment";
import Dashboard from "./pages/Dashboard";
import UploadLaptimes from "./pages/UploadLaptimes";
import CompareLaptimes from "./pages/CompareLaptimes";
import Coach from "./pages/Coach";
import Settings from "./pages/Settings";
import PrivateRoute from "./components/PrivateRoute";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import EmailConfirmation from "./pages/EmailConfirm";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";

const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || process.env.STRIPE_PUBLISHABLE_KEY;
const stripePromise = stripeKey ? loadStripe(stripeKey) : null;

function App() {
  const [isPayment, setIsPayment] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [page, setPage] = useState("landing");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [cardHolder, setCardHolder] = useState("");
  const [showSidebar, setShowSidebar] = useState("");
  const [figureImage, setFigureImage] = useState(null);
  const [dropdownStates, setDropdownStates] = useState([]);
  const [raceResultLoaded, setRaceResultLoaded] = useState(false);
  const [isSettings, setIsSettings] = useState(false);

  const setPremiumState = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/get-premium-status`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      setIsPremium(data.premium);
    } catch (error) {
      console.log("Error fetching premium status:", error);
    }
  };

  useEffect(() => {
    page === "settings" ? setIsSettings(true) : setIsSettings(false);
  }, [page]);

  useEffect(() => {
    // get cached user id
    const stored = localStorage.getItem("sb_id");

    console.log("Stored user:", stored);

    if (!stored) return;
    let user;
    try {
      user = JSON.parse(stored);
    } catch {
      return;
    }

    setPremiumState();

    console.log(isPremium);

    const userId = user?.id ?? user?.user_metadata?.sub;
    if (!userId) return;

    const socket = io(
      process.env.BACKEND_URL,
      {
        transports: ["websocket"],
      }
    );

    // join server-side room for this user
    socket.emit("join", userId);

    socket.on("user:premium_updated", (payload) => {
      if (payload?.premium !== undefined) {
        setIsPremium(Boolean(payload.premium));
        // optionally update cached user/profile in localStorage
        if (payload.user)
          localStorage.setItem("sb_id", JSON.stringify(payload.user));
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <>
      <Router>
        <Header page={page} setPage={setPage} />
        <Routes>
          <Route
            path="/"
            element={
              <LandingPage onPlanSelect={setIsPayment} setPage={setPage} />
            }
          />
          <Route
            path="/login"
            element={
              <Login
                email={email}
                setEmail={setEmail}
                password={password}
                setPassword={setPassword}
              />
            }
          />
          <Route
            path="/create-account"
            element={
              <CreateAccountPage
                isPayment={isPayment}
                name={name}
                email={email}
                password={password}
                confirmPassword={confirmPassword}
                setName={setName}
                setEmail={setEmail}
                setPassword={setPassword}
                setConfirmPassword={setConfirmPassword}
              />
            }
          />
          <Route
            path="/payment"
            element={
              <Elements stripe={stripePromise}>
                <PaymentPage
                  cardHolder={cardHolder}
                  setCardHolder={setCardHolder}
                />
              </Elements>
            }
          />
          <Route
            path="/email-confirmation"
            element={
              <EmailConfirmation
                isPayment={isPayment}
                email={email}
                password={password}
              />
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard
                  showSidebar={setShowSidebar}
                  sidebar={showSidebar}
                  setPage={setPage}
                />
              </PrivateRoute>
            }
          />
          <Route
            path="/gear-figure"
            element={
              <PrivateRoute>
                <UploadLaptimes
                  setShowSidebar={setShowSidebar}
                  showSidebar={showSidebar}
                  setPage={setPage}
                  page={page}
                  isPremium={isPremium}
                  figureImage={figureImage}
                  setFigureImage={setFigureImage}
                />
              </PrivateRoute>
            }
          />
          <Route
            path="/lap-time-comparison"
            element={
              <PrivateRoute>
                <CompareLaptimes
                  setShowSidebar={setShowSidebar}
                  showSidebar={showSidebar}
                  setPage={setPage}
                  page={page}
                  isPremium={isPremium}
                  figureImage={figureImage}
                  setFigureImage={setFigureImage}
                />
              </PrivateRoute>
            }
          />
          <Route
            path="/ai-coach"
            element={
              <PrivateRoute>
                <Coach
                  setShowSidebar={setShowSidebar}
                  showSidebar={showSidebar}
                  page={page}
                  dropdownStates={dropdownStates}
                  setDropdownStates={setDropdownStates}
                  setPage={setPage}
                  setFigureImage={setFigureImage}
                  raceResultLoaded={raceResultLoaded}
                  setRaceResultLoaded={setRaceResultLoaded}
                />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Settings
                  showSidebar={showSidebar}
                  setPage={setPage}
                  isSettings={isSettings}
                />
              </PrivateRoute>
            }
          />
          <Route
            path="/change-password"
            element={<ChangePassword setPage={setPage} />}
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
